module.exports = __webpack_public_path__ + "static/media/Inter-ExtraLight.7d759358.woff";